import React from 'react';

import { Box } from '@mui/material';

import { useStyles } from './TabCountBadge.styles';

export interface ITabCountBadgeProps {
  count: number;
  selected?: boolean;
}

const TabCountBadge: React.FC<ITabCountBadgeProps> = ({
  count,
  selected = false,
}) => {
  const { classes } = useStyles({ selected });

  return (
    <Box component="span" className={classes.root}>
      {count}
    </Box>
  );
};

export default TabCountBadge;
